export default __webpack_public_path__ + "static/media/outlook-calendar.fb08e0cd.svg";